import axios from "axios";

const API_URL = process.env.REACT_APP_API_KEY;

const postInstituicao = async (
  token: string,
  nome: string,
  cnpj: string,
  email: string,
  telefone: string,
  cep: string,
  cidade: string,
  estado: string,
  bairro: string,
  rua: string,
  numero: string,
  complemento?: string
) => {
  const status = "pendente";

  const config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };
  const response = await axios.post(
    `${API_URL}/instituicoes`,
    {
      nome,
      cnpj,
      email,
      telefone,
      cep,
      cidade,
      estado,
      bairro,
      rua,
      numero,
      complemento,
      status,
    },
    config
  );
  return response.data;
};
export default postInstituicao;
